import React from 'react';
import styles from './AdPrices.module.scss';
import PriceBox from './components/priceBox/PriceBox';

interface IAdPricesProps {
  originalPriceLabel: any;
  originalPrice: number;
  originalPriceClassName?: string;
  salePriceLabel: any;
  salePrice: number;
  currency: number;

  className?: string;

  loading?: boolean;
}

const AdPrices = (props: IAdPricesProps) => (
  <div className={`${styles.prices} ${props.className}`.trim()}>

    <PriceBox
      label={props.originalPriceLabel}
      price={props.originalPrice}
      priceClassName={`${styles.originalPrice} ${props.originalPriceClassName}`.trim()}
      currency={props.currency}
      loading={props.loading}
    />
    <PriceBox
      label={props.salePriceLabel}
      price={props.salePrice}
      priceClassName={styles.salePrice}
      currency={props.currency}
      loading={props.loading}
    />


  </div>

);

AdPrices.defaultProps = {
  salePriceLabel: 'מחיר מכירה',
  originalPriceLabel: 'מחיר מקורי',
  price: 0,
  currency: 0,
  originalPriceClassName: '',
};
export default AdPrices;
